export enum PickupListCode {
    UserStatus = "LIST_CODES",
    TypeOfPermission = "TYPE_OF_PERMISSION",
    WaterSupplyType = "WATER_SUPPLY_TYPE",
    ToiletType = "TOILET_TYPE",
    BorewellFacilityType = "BOREWELL_FACILITY_TYPE"
}